import React, { useCallback, useEffect, useState } from "react";
import CampaignSkeleton from "../skeletons/CampaignSkeleton";
import { useMediaQuery } from "react-responsive";
import { isDesktopMediaQuery } from "../constants/constants";
import CollaborationCard from "../components/collaborations/CollaborationCard";
import InfluencerCollaborationInsights from "../components/collaborations/InfluencerCollaborationInsights";
import UploadCollaborationMedia from "../components/collaborations/UploadCollaborationMedia";
import { Link } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroll-component";
import { useDispatch } from "react-redux";
import { AppDispatch, RootState } from "../redux-stores/store";
import { fetchCollaborations } from "../redux-stores/slices/collaborationSlice";
import { useSelector } from "react-redux";
import InfluencerActionCard from "../components/influencer/InfluencerActionCard";
import { POSTAPIError } from "../types";
import { ERROR } from "../constants/errors";
import GenericErrorsCTAModal from "../components/CTA/GenericErrorsCTAModal";
import InsufficientPermissionsCTAModal from "../components/CTA/InsufficientPermissionsCTAModal";
import InfluencerActionCardModal from "../components/influencer/InfluencerActionCardModal";

const Collaborations: React.FC = () => {
    const dispatch: AppDispatch = useDispatch();

    const connectionRequired = useSelector((state: RootState) => state.influencer.connectionRequired);
    const [connectionRequiredModalVisibility, setConnectionRequiredModalVisibility] = useState<boolean>(false);

    const { items: collaborations, loading, page, has_more } = useSelector(
        (state: RootState) => state.collaborations
    );

    const [insightsVisibile, setInsightsVisible] = useState<string | null>(null);
    const [uploadMedia, setUploadMedia] = useState<string | null>(null);
    const [collabError, setCollabError] = useState<POSTAPIError | null>(null)

    const isDesktop = useMediaQuery(isDesktopMediaQuery)

    const nextPage = () => {
        if (has_more) {
            const nextPageNumber = page + 1;
            fetchCollaborationData(nextPageNumber)
        }

    }

    const fetchCollaborationData = useCallback(async (pageNumber: number) => {
        await dispatch(fetchCollaborations({ page: pageNumber }));
    }, [dispatch])

    useEffect(() => {
        fetchCollaborationData(1);
    }, [fetchCollaborationData])

    return (
        <div>
            <InfiniteScroll
                className="p-0"
                hasMore={has_more}
                next={nextPage}
                dataLength={collaborations.length}
                loader={<></>}

            >
                {
                    collaborations.map((collaborationApplication, i) => <CollaborationCard uploadWork={(campaignId) => {
                        if(connectionRequired)
                            return setConnectionRequiredModalVisibility(true);

                        setUploadMedia(campaignId)
                    }} viewInsights={(campaignId: string) => setInsightsVisible(campaignId)} collaborationApplication={collaborationApplication} key={i} />)
                }
            </InfiniteScroll>
            {
                loading && Array.from({ length: isDesktop ? 3 : 2 }).map((_, i) => <CampaignSkeleton key={i} />)
            }
            {
                !loading && collaborations.length === 0 &&
                <div className="card h-full card-style rounded-card">
                    <div className="card-body">
                        <div className="h-200px d-flex justify-content-center align-items-center text-center">
                            <div>
                                <h2 className="pop">You have not applied to any campaign</h2>
                                <p className="text-gray-600">Apply on campaigns to get a chance to collaborate with brands</p>
                                <Link className="btn btn-sm rounded-sm btn-primary" to="/">Go to Campaigns</Link>
                            </div>
                        </div>
                    </div>
                </div>
            }
            <InfluencerCollaborationInsights campaignId={insightsVisibile ?? ''} isActive={insightsVisibile ? true : false} onClose={() => setInsightsVisible(null)} />
            <UploadCollaborationMedia campaignId={uploadMedia ?? ''} isActive={uploadMedia ? true : false} onClose={() => setUploadMedia(null)} onUploadError={(error: POSTAPIError) => setCollabError(error)} />
            <React.Fragment>
                <InsufficientPermissionsCTAModal
                    isActive={(collabError && collabError.error_code === ERROR.INSUFFICIENT_PERMISSIONS) ? true : false}
                    onClose={() => setCollabError(null)}
                    missing_permissions={collabError?.missing_permissions!}
                    feature={collabError?.feature!}
                />
                <GenericErrorsCTAModal
                    isActive={(collabError && collabError.error_code !== ERROR.INSUFFICIENT_PERMISSIONS) ? true : false}
                    onClose={() => setCollabError(null)}
                    error={collabError!}
                />
            </React.Fragment>

            <InfluencerActionCardModal
                collabPage
                isActive={connectionRequiredModalVisibility}
                onClose={() => setConnectionRequiredModalVisibility(false)}
            />
        </div>
    )
}

export default Collaborations;